import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { createCategory, fetchCategory, removeCategory, updateCategory } from "../../service/api";

export const getCategory = createAsyncThunk(
    "category/getAll",
    async (params, { rejectWithValue }) => {

        try {
            const response = await fetchCategory(params)
            console.log("response", response)
            return response.data

        } catch (error) {
            return rejectWithValue(err.response.data || err.message)
        }
    }
)


export const addCategory = createAsyncThunk(
    "category/add",
    async (params, { rejectWithValue }) => {

        try {
            const response = await createCategory(params)
            console.log("response", response)

        } catch (error) {
            return rejectWithValue(err.response.data || err.message)
        }
    }
)

export const editCategory = createAsyncThunk(
    "category/edit",
    async (params, { rejectWithValue }) => {

        try {
            const response = await updateCategory(params)
            console.log("response", response)

        } catch (error) {
            return rejectWithValue(err.response.data || err.message)
        }
    }
)


export const deleteCategory = createAsyncThunk(
    "category/delete",
    async (params, { rejectWithValue }) => {

        try {
            const response = await removeCategory(params)
            console.log("response", response)

        } catch (error) {
            return rejectWithValue(err.response.data || err.message)
        }
    }
)



const categorySlice = createSlice({
    name: "categories",
    initialState: {
        categoryList: [],
        isLoading: false,
        actionLoader: false,
        error: null,
        totalPage: 0,
        current: 1,
        limit: 10,
        searchParams: null
    },
    reducers: {
        setPagination: (state, action) => {
            state.current = action.payload;
        },
        setSearchParams: (state, action) => {
            state.searchParams = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getCategory.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getCategory.fulfilled, (state, action) => {
                state.isLoading = false,
                    state.categoryList = action.payload.data
                state.totalPage = action.payload.totalPages
            })
            .addCase(getCategory.rejected, (state) => {
                state.isLoading = true,
                    state.error = null
            })

            //Post 

            .addCase(addCategory.pending, (state) => {
                state.actionLoader = true
            })
            .addCase(addCategory.fulfilled, (state, action) => {
                state.actionLoader = false

            })
            .addCase(addCategory.rejected, (state) => {
                state.actionLoader = false
            })

            //put 

            .addCase(editCategory.pending, (state) => {
                state.actionLoader = true
            })
            .addCase(editCategory.fulfilled, (state, action) => {
                state.actionLoader = false

            })
            .addCase(editCategory.rejected, (state) => {
                state.actionLoader = false
            })

            //delete 

            .addCase(deleteCategory.pending, (state) => {
                state.actionLoader = true
            })
            .addCase(deleteCategory.fulfilled, (state, action) => {
                state.actionLoader = false

            })
            .addCase(deleteCategory.rejected, (state) => {
                state.actionLoader = false
            })
    }
})
export const { setSearchParams, setPagination } = categorySlice.actions;

export default categorySlice.reducer